<template>
<div>
    <div class="weui-panel weui-panel_access" v-if="data != null && data.items.length > 0">
        <div class="weui-panel__hd">我的阅读记录</div>
        <div class="weui-panel__bd">
            <router-link :to="getRoute(item)" class="weui-media-box weui-media-box_appmsg" v-for="item in data.items" :key="item.id">
                <div class="weui-media-box__hd">
                    <img class="weui-media-box__thumb" :src="item.service_cover" alt="">
                </div>
                <div class="weui-media-box__bd">
                    <h4 class="weui-media-box__title">{{item.service_title}}</h4>
                        <ul class="weui-media-box__info">
                        <li class="weui-media-box__info__meta">{{item.category_name}}</li>
                        <li class="weui-media-box__info__meta weui-media-box__info__meta_extra">{{item.user_service_title}}</li>
                        <li class="weui-media-box__info__meta weui-media-box__info__meta_extra">{{item.updated_at}}</li>
                    </ul>
                </div>
            </router-link>
            <br />
        </div>
    </div>

    <msg :info="msgInfo" v-if="data == null || data.items.length == 0" @click="showFinder"/>
</div>
</template>

<script>
import Msg from "./components/Msg";

export default {
    name: "HomeHistory",
    data: function() {
        return {
            data: null,
            msgInfo: {
                icon: 'info',
                title: '您还没有访问任何内容',
                buttons: [
                    {
                        title: "去逛逛",
                        primary: true
                    }
                ]
            }
        };
    },
    created () {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        this.fetchData()
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'fetchData'
    },
    computed: {
        renewRoute() {
            return {
                path: `/user/member`
            }
        },
        tabSelectedIndex: {
            get () {
                return this.$store.state.home.tabSelectedIndex
            },
            set (val) {
                this.$store.commit("home/tabSelectedIndex", val)
            }
        }
    },
    methods: {
        fetchData: function() {
            this.$store.commit('loading');
            this.$axios.get("user/service").then(response => {
                this.data = response.data;

                this.$store.commit('loading', false);
            });
        },
        getRoute: function(item) {
            return {
                path: `/service/${item.id}${item.route}/${item.location}`
            }
        },
        showFinder() {
            this.tabSelectedIndex = 0
        }
    },
    components: {
        Msg
    }
};
</script>
